import React, { useCallback, useEffect, useRef } from "react";

import { convertToSlug } from "../../utils/convertToSlug";
import TabsWrapper from "../shared/tabs/tabsWrapper";

const ProgramTabs = ({
  tabs = [],
  currentSlide,
  setCurrentSlide,
  isTab,
  setIsTab = () => {}
}) => {
  const tabsRef = useRef(null);
  const goToScroll = () => tabsRef.current.scrollIntoView();

  const handleNextSlide = useCallback(() => {
    if (currentSlide === tabs.length - 1) setCurrentSlide(0);
    else setCurrentSlide((c) => c + 1);
  }, [currentSlide, tabs]);

  const updateNavigator = useCallback(
    (idx) => {
      const updatedSlide = idx === undefined ? 0 : idx;
      setCurrentSlide(updatedSlide);
      if (isTab === true || updatedSlide !== 0) {
        setIsTab(true);
        const url = new URL(window?.location);
        url.searchParams.set("tab", convertToSlug(tabs[updatedSlide].title));
        window?.history.pushState({}, "", url);
      }
    },
    [isTab, tabs]
  );

  useEffect(() => {
    let url = new URL(window?.location?.href);
    const currentTabTitle = url.searchParams.get("tab");
    if (!currentTabTitle) {
      setCurrentSlide(0);
      setIsTab(false);
    } else {
      const tab = tabs?.filter((tab) => tab?.accordionSlug === currentTabTitle);

      //update the interaction local storage
      const pageInteraction = JSON.parse(
        typeof window !== "undefined"
          ? window?.localStorage?.getItem("pageViewInteraction")
          : false
      );

      //add a tab selection to the tracker
      let pageViewList = [...pageInteraction];

      if (!pageViewList?.includes(url?.href)) {
        pageViewList?.push(url?.href);

        window?.localStorage?.setItem(
          "pageViewInteraction",
          JSON.stringify(pageViewList)
        );
      }

      setCurrentSlide(tab ? tab[0]?.id : currentSlide);
      goToScroll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section
        className="flex items-center justify-center w-[calc(100vw-12px)] px-4 pt-20 pb-5 md:py-20 mx-auto bg-white md:w-full md:px-0 dark:gvi-dark-gray-bg"
        id={"view-tabs"}
      >
        <div className="container relative flex flex-col w-full mb-6">
          <div
            className="relative justify-between w-full sm:flex"
            ref={tabsRef}
          >
            {tabs && (
              <TabsWrapper
                tabs={tabs}
                defaultSelectedTab={currentSlide}
                updateSelectedTab={updateNavigator}
                standalone={false}
                isVertical={true}
              />
            )}
          </div>
          <div className="relative">
            {tabs && tabs.length > 0 && (
              <button
                onClick={handleNextSlide}
                className="text-base leading-[19px] dark:text-white text-black-lighter underline"
              >
                {currentSlide === tabs.length - 1 ? (
                  <span>Read about {tabs[0]?.title} next</span>
                ) : (
                  <span>Read about {tabs[currentSlide + 1]?.title} next</span>
                )}
              </button>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgramTabs;
